<template>
  <div class="warning-alert">
    {{ message }}
  </div>
</template>

<style>
.warning-alert {
  background-color: #fff3cd !important;
  text-transform: uppercase;
  margin-bottom: 10px;
  border-radius: 4px;
  padding: 10px;
  color: #997404;
  font-size: 13px;
  font-weight: 500;
}
</style>
<script>
export default {
  name: "WarningMessage",
  props: {
    message: String,
  },
};
</script>
